import { IRequest } from '@r1-frontend/shared/types/IRequest';

export interface IRegistrationResponse {
    loyaltyId: number,
    loyaltyNumber: number,
    welcomeBonus: number,
}

interface IRegistrationRequest {
    phone: string,
    email?: string,
}

/*
* Регистрация в программе лояльности
* https://master.api-loyalty.sandbox.d2c.r-one.io/docs/v1#/Loyalty%20Program/5c4fe33f98b84c5b4989aef001289340
* */
export const registration = (providerId: number, { email = '', phone }: IRegistrationRequest): IRequest => ({
    uri: '/v1/program/registration',
    method: 'POST',
    withAuth: true,
    headers: { providerId: `${providerId}` },
    body: JSON.stringify({
        phoneNumber: phone,
        email,
    }),
});
